import { Navigate } from 'react-router-dom'
import Dashboard from '@pages/app/dashboard'
import Upload from '@pages/app/upload'

// Auth
import Login from '@pages/authentication/login'
import ForgotPassword from '@pages/authentication/forgot-password'
import SignUp from '@pages/authentication/sign-up'
import Confirm from '@pages/authentication/confirm'
import Review from '@/pages/app/review'
import CheckoutCallback from '@pages/app/checkout-callback'
import ResetPassword from '@/pages/authentication/reset-password'
import Verify from '@/pages/authentication/verify'
import Restricted from '@/pages/authentication/restricted'
import EditorPage from '@/pages/app/editor'
import ReadonlyDocPage from '@/pages/app/readonly-doc'
import EmailUnsubscribePage from '@/pages/app/email-unsubscribe'
import AdministratorPage from '@/pages/administrator/administrator'

const authProtectedRoutes = [
  { path: '/checkout-callback', component: <CheckoutCallback /> },
  { path: '/dashboard', component: <Dashboard /> },
  { path: '/upload', component: <Upload /> },
  { path: '/review/:id', component: <Review /> },
  { path: '/administrator', component: <AdministratorPage /> },
  { path: '/editor', component: <EditorPage /> },
  { path: '/readonly', component: <ReadonlyDocPage /> },
  { path: '/', exact: true, component: <Navigate to="/dashboard" /> },
  { path: '/email-unsubscribe', component: <EmailUnsubscribePage /> },
]

const publicRoutes = [
  { path: '/sign-up', component: <SignUp /> },
  { path: '/confirm', component: <Confirm />, disableRedirect: true },
  { path: '/verify', component: <Verify /> },
  { path: '/restricted', component: <Restricted /> },
  { path: '/login', component: <Login />, disableRedirect: true },
  { path: '/forgot-password', component: <ForgotPassword /> },
  { path: '/reset-password', component: <ResetPassword />, disableRedirect: true },
  { path: '/doc', component: <ReadonlyDocPage />, disableRedirect: true, layout: 'blank' },
]

export { authProtectedRoutes, publicRoutes }
